// import constants
import l from './localizationLabels';
// import enums
import { AchievementPeriod, AchievementProductEnum } from 'enums/achievement';

export const MAX_ACHIEVEMENT_CHALLENGES_COUNT = 3;

// Defines, in order, which response fields form the selection hierarchy of each product.
// CheckboxTreeList derives every node's id/parent/level purely from this order and from which of
// these fields are non-nil on a given row, so adding a level only requires appending it here.
export const CASINO_SELECTION_HIERARCHY = ['ProviderId', 'CategoryId', 'GameId'] as const;
export const SPORT_SELECTION_HIERARCHY = ['SportId', 'RegionId', 'CompetitionId'] as const;
// Payment has no hierarchy — a flat list of payment systems, so a single level. Such a tree's node
// key is the raw id, which is what makes a selection map straight to [{ Id }, ...].
export const PAYMENT_SELECTION_HIERARCHY = ['Id'] as const;

export const CHALLENGE_SELECTION_LABEL_KEY = 'Name';

// Everything that differs between the products' selection trees, in one place. Keyed by the
// challenge `productId`, so the tab only has to look up its own entry.
export const CHALLENGE_SELECTION_CONFIG = {
    [AchievementProductEnum.Casino]: {
        hierarchy: CASINO_SELECTION_HIERARCHY,
        labelKey: CHALLENGE_SELECTION_LABEL_KEY,
        title: l.Providers,
        infoText: l.SelectingAProviderAppliesToAllExistingAndFutureGamesAndCategories,
        selectAllTooltipText: l.AchievementProvidersSelectAllInfo,
        rootWildcardText: l.AllCategoriesAndGamesUnderProviderAreSelected,
        parentWildcardText: l.AllGamesUnderCategoryAreSelected,
        allSelectedDescription: l.AllTheListedGameProvidersHaveBeenSelected,
    },
    [AchievementProductEnum.Sport]: {
        hierarchy: SPORT_SELECTION_HIERARCHY,
        labelKey: CHALLENGE_SELECTION_LABEL_KEY,
        title: l.Sports,
        infoText: l.SelectingASportAppliesToAllExistingAndFutureRegionsAndCompetitions,
        selectAllTooltipText: l.AchievementSportsSelectAllInfo,
        rootWildcardText: l.AllRegionsAndCompetitionsUnderSportAreSelected,
        parentWildcardText: l.AllCompetitionsUnderRegionAreSelected,
        allSelectedDescription: l.AllTheListedSportsHaveBeenSelected,
    },
    [AchievementProductEnum.Payment]: {
        hierarchy: PAYMENT_SELECTION_HIERARCHY,
        labelKey: CHALLENGE_SELECTION_LABEL_KEY,
        title: l.PaymentSystems,
        // A flat list has no child items whose behaviour needs explaining
        infoText: undefined,
        selectAllTooltipText: l.AchievementPaymentSystemsSelectAllInfo,
        // A single level selection is never a wildcard over anything, so neither text can render
        rootWildcardText: undefined,
        parentWildcardText: undefined,
        allSelectedDescription: l.AllTheListedPaymentSystemsHaveBeenSelected,
    },
} as const;

// Columns of the popover listing a challenge's per-currency amounts — see DynamicRowList
export const CHALLENGE_AMOUNT_COLUMNS_CONFIG = [
    {
        columnName: 'Currency',
        columnLabel: l.Currency,
    },
    {
        columnName: 'Amount',
        columnLabel: l.Amount,
    },
];

export const ACHIEVEMENT_PRODUCT_LABELS = {
    [AchievementProductEnum.Casino]: l.Casino,
    [AchievementProductEnum.Sport]: l.Sport,
    [AchievementProductEnum.Payment]: l.Payment,
};

export const ACHIEVEMENT_PERIOD_LABELS = {
    [AchievementPeriod.Day]: l.Day,
    [AchievementPeriod.Week]: l.Week,
    [AchievementPeriod.Month]: l.Month,
    [AchievementPeriod.Year]: l.Year,
};

export const ACHIEVEMENT_PERIOD_LABELS_PLURAL = {
    [AchievementPeriod.Day]: l.Days,
    [AchievementPeriod.Week]: l.Weeks,
    [AchievementPeriod.Month]: l.Months,
    [AchievementPeriod.Year]: l.Years,
};
